import { useDispatch, useSelector } from 'react-redux'
import { Pagination } from '../../../common/pagination'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../layout/LayoutContainer'
import { SIDE_BAR_SCROLL_ID } from '../../SideBarUserManagement'
import classes from './index.module.scss'
import { changeFilter, selectFilterByKey } from './store/slice'

export const TableFooter = () => {
  const dispatch = useDispatch()

  const page = useSelector(selectFilterByKey('page'))
  const pageSize = useSelector(selectFilterByKey('pageSize'))
  const totalRecords = useSelector(selectFilterByKey('totalRecords'))

  const setPage = (page) => {
    dispatch(changeFilter({ page }))
  }

  const setPageSize = (pageSize) => {
    dispatch(changeFilter({ pageSize }))
  }

  return (
    <Pagination
      className={classes.tableFooter}
      page={page}
      pageSize={pageSize}
      total={totalRecords}
      setPage={setPage}
      setPageSize={setPageSize}
      scrollId={[SIDE_BAR_SCROLL_ID, SCROLL_LAYOUT_ELEMENT_ID]}
    />
  )
}
